import DefaultFiatInput from './components/variations/Default';
import WithdrawRequestFiatInput from './components/variations/WithdrawRequest';

const FiatInput = {
	Default: DefaultFiatInput,
	WithdrawRequest: WithdrawRequestFiatInput,
};

export default FiatInput;
